
<div [className]="className" [style]="styleName">

      <div [className]="inputClass" [style]="inputStyle" >

           <div [className]="textClass" [style]="textStyle" tabindex="0" (blur)="tabMenu($event)"> 
                 <ng-content></ng-content>
                 <div tabindex="0" (focus)="tabMenuRootDiv()"></div>
           </div>
          
      </div>
</div>            
<div class="box-background"></div>